import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Input, Label, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE, CALENDAR,
    deleteMsg,
    error,
    LIST,
    NO, selectMarker,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonCalendarView,
    ButtonClean, ButtonListView,
    ButtonSearch,
    ButtonTableDelete,
    ButtonTableEdit,
    ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {seasonService} from "../../../jwt/_services/clasificator/seasonService";
import Select from "react-select";
import {useForm} from "react-hook-form";
import {typeSeasonProvider} from "../../../providers/typeSeasonProvider";
import CalendarContainer from "../../../components/calendar/calendarContainer";
import {utilHelper} from "../../../jwt/_helpers";

export default function SeasonList(props) {

    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const [typeSeason, setTypeSeason] = useState(null);
    const [typeSeasonOptions, setTypeSeasonOptions] = useState([]);
    const [dataFilter, setDataFilter] = useState({
        typeSeason: null,
    });
    const [viewMode, setViewMode] = useState('CALENDAR');
    const [selectedItem, setSelectedItem] = useState({});
    const [events, setEvents] = useState([]);
    const [calendarChange, setCalendarChange] = useState(false);

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage, dataFilter, viewMode);
        typeSeasonProvider.getOptions()
            .then(result => {
                if (result)
                    setTypeSeasonOptions(result);
                if (props.item?.typeSeason) {
                    typeSeasonProvider.getItem(typeSeason?.id)
                        .then(data => {
                            setTypeSeason(data);
                        });
                }
            })
            .catch(_ => {
            })
    }, []);


    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage;
        refreshDataList(page, index, sizePerPage, dataFilter, viewMode);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, dataFilterP, viewModeP) => {
        setSelectedItem({});

        switch (viewModeP) {
            case "LIST":
                setLoading(true);
                seasonService.search(dataFilterP, currentIndex, sizePerPage)
                    .then(result => {
                        if (result){
                            setListItems(result.data);
                            setTotalSize(result.total);
                            setCurrentIndex(currentIndex);
                            setPage(page);
                            setSizePerPage(sizePerPage);
                        } else {
                            setListItems([]);
                            setTotalSize(0);
                            setCurrentIndex(0);
                            setPage(1);
                            setSizePerPage(10);
                        }
                        setLoading(false);
                    })
                    .catch(errorMessage => {
                        setLoading(false);
                        setListItems([]);
                        setTotalSize(0);
                        setCurrentIndex(0);
                        setPage(1);
                        setSizePerPage(10);
                        showToastCustom(error, errorMessage);
                    });
                return;
            case "CALENDAR":
                setLoading(true);
                seasonService.searchCalendar(dataFilterP)
                    .then(result => {
                        if (result){
                            setListItems(result.data);
                            mapEvents(result.data);
                        } else {
                            setListItems([]);
                            mapEvents([]);
                        }
                        setLoading(false);
                    })
                        .catch(errorMessage => {
                            setListItems([]);
                            mapEvents([]);
                            showToastCustom(error, errorMessage);
                        });
                return;
        }
    }

    const mapEvents = (data) => {
        let eventArray = [];
        data.map((seasonItem) => {

            eventArray.push({
                id: seasonItem.id,
                title: seasonItem.typeSeasonName,
                allDay: true,
                start: getFormattedDate(seasonItem.startDate, 0),
                end: getFormattedDate(seasonItem.endDate, 1),
                color: getColorByType(seasonItem.typeSeason?.code)
            })
        });
        setEvents(eventArray);
        setCalendarChange(true);
    };

    const getColorByType = (code) => {
        switch (code) {
            case "DF":
                return "red";
            case "H":
                return "green";
            case "L":
                return "default";
        }
    }

    const getFormattedDate = (datep, addDays) => {
        const today = new Date();
        const y = today.getFullYear();
        const m = datep.split('/')[1];
        const d = datep.split('/')[0];
        const date = y + '/' + m + '/' + ( parseInt(d) + addDays );

        return utilHelper.calendarDateFormatter(date);
    }

// ----------------------------------------------
//            FORM BEHAVIOR
// ----------------------------------------------

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const togleView = (mode) => {
        setEvents([]);
        setViewMode(mode);
        setSelectedItem({});
        refreshDataList(page, currentIndex, sizePerPage, dataFilter, mode);
    }

    const onEventClick = (seasonItem) => {
        const itemToEdit = listItems.find(n => n.id === seasonItem.id);
        setSelectedItem(itemToEdit);
    }

    const cleanFields = () => {
        reset();
        const dataRequest = {
            typeSeason: null
        };
        setTypeSeason(null);
        setDataFilter(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest, viewMode);
    }

    // ----------------------------------------------
    //            TABLE METHODS
    // ----------------------------------------------
    const confirmDelete = (data) => {
        if (data.id === undefined) {
            showToastCustom(error, selectMarker, true);
            return;
        }

        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        seasonService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                refreshDataList(page, currentIndex, sizePerPage);
                showToastCustom(warning, deleteMsg, true);
            });
    }

    const editItem = (data) => {
        if (data.id === undefined) {
            showToastCustom(error, selectMarker, true);
            return;
        }

        const itemToEdit = listItems.find(n => n.id === data.id);
        props.beginEdit(itemToEdit);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({});
    const onSubmit = (data, _) => {
        const dataRequest = {
            typeSeason: typeSeason
        };
        setDataFilter(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest, viewMode);
    };

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onSeasonChange = (value) => {
        setTypeSeason(value);
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const getCalendarForm = () => {
        return (
            <Row className={"pb-3"}>
                <Col md="6">
                    <Label htmlFor="typeSeasonName">Tipo</Label>
                    <Input type="text" name="typeSeasonName"
                           readOnly
                           defaultValue={selectedItem.typeSeasonName}
                    />
                </Col>
                <Col md="2">
                    <Label htmlFor="startDate">Desde</Label>
                    <Input type="text" name="startDate"
                           readOnly
                           defaultValue={selectedItem.startDate}
                    />
                </Col>
                <Col md="2">
                    <Label htmlFor="endDate">Hasta</Label>
                    <Input type="text" name="endDate"
                           readOnly
                           defaultValue={selectedItem.endDate}
                    />
                </Col>
                <Col md="2">
                    <div className="float-right map_form_buttons">
                        <ButtonTableDelete onClick={() => confirmDelete(selectedItem)}/>
                        <ButtonTableEdit onClick={() => editItem(selectedItem)}/>
                    </div>
                </Col>
            </Row>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'typeSeasonName',
        text: 'Tipo de temporada',
        headerStyle: {width: '50px'},
        sort: true
    }, {
        dataField: 'startDate',
        text: 'Desde',
        headerStyle: {width: '50px'},
        sort: true
    }, {
        dataField: 'endDate',
        text: 'Hasta',
        headerStyle: {width: '50px'},
        sort: true
    }, {
        dataField: 'status',
        headerStyle: {width: '30px'},
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '80px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    {
                        viewMode === 'LIST' ?
                            <div className="float-left">
                                <i className="far fa-list-alt mr-2"> </i> {LIST}
                            </div>
                            :
                            <div className="float-left">
                                <i className="far fa-calendar mr-2"> </i> {CALENDAR}
                            </div>
                    }
                    <div className="float-right card_header_buttons">
                        <ButtonListView onClick={() => togleView('LIST')}/>
                        <ButtonCalendarView onClick={() => togleView('CALENDAR')}/>
                    </div>
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="8">
                                    <FormGroup>
                                        <Select
                                            value={typeSeason}
                                            options={typeSeasonOptions}
                                            onChange={onSeasonChange}
                                            innerRef={register}
                                            placeholder="Selecciona un tipo de temporada"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" className="d-flex justify-content-center">
                                    <div className="float-right">
                                        <ButtonSearch/>
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>
                </Collapse>
                <CardBody className="border-top">
                    {loading && showLoader()}
                    {
                        viewMode === 'LIST' ?
                                <BootstrapTable
                                    striped hover
                                    tableHeaderClass='mb-0'
                                    remote
                                    keyField="id"
                                    data={listItems}
                                    columns={columns}
                                    pagination={paginationFactory({page, sizePerPage, totalSize})}
                                    onTableChange={handleTableChange}
                                />
                            :
                            <div>
                                {getCalendarForm()}

                                <Row>
                                    <Col md="12">
                                        {calendarChange &&
                                        <CalendarContainer events={events} onEventClick={onEventClick} createNew={props.createNew}/>}
                                    </Col>
                                </Row>
                            </div>
                    }
                </CardBody>
            </Card>
        </div>
    )
}
